import type { AxiosRequestConfig } from 'axios';
import { Page, PaginationParams } from '@/shared/api/pagination';
import type {
  AccessRuleTQLBriefDTOResponse,
  AccessRuleTQLCreateRequest,
  AccessRuleTQL,
} from '@/entities/user/access-rule';

import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';
export class AccessRulesTQLApi {
  static getRulesBrief(
    params: PaginationParams,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.get<Page<AccessRuleTQLBriefDTOResponse>>(
      `/tql/rules_brief`,
      {
        ...options,
        params,
      },
    );
  }

  static getRuleById(rule_id: string, options: AxiosRequestConfig = {}) {
    return srmInstance.get<AccessRuleTQL>(`/tql/rule/${rule_id}`, options);
  }

  static updateRule(
    rule_id: string,
    payload: AccessRuleTQLCreateRequest,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.put<AccessRuleTQL>(
      `/tql/rule/${rule_id}`,
      payload,
      options,
    );
  }

  static createRule(
    payload: AccessRuleTQLCreateRequest,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.post<AccessRuleTQL>(`/tql/rule`, payload, options);
  }

  static deleteRule(rule_name: string, options: AxiosRequestConfig = {}) {
    return srmInstance.delete(`/tql/rule/${rule_name}`, options);
  }

  static getActions(options: AxiosRequestConfig = {}) {
    return srmInstance.get(`/tql/rules/actions`, options);
  }

  static getAccesses(options: AxiosRequestConfig = {}) {
    return srmInstance.get(`/tql/rules/accesses`, options);
  }

  static getTQLsByRuleId(
    rule_id: string,
    params: PaginationParams,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.get(`/tql/rule/${rule_id}/tqls`, {
      ...options,
      params,
    });
  }
}